export const SET_VAR_DETAIL_LOCATION_LIST = "SET_VAR_DETAIL_LOCATION_LIST";
export const SET_LOCATION_LIST_BY_USER_ID = "SET_LOCATION_LIST_BY_USER_ID";
export const SET_LOCATION_LIST_BY_CITY = "SET_LOCATION_LIST_BY_CITY";
export const SET_CART_ITEM_LIST = "SET_CART_ITEM_LIST";
export const SET_LOCATION_DETAIL = "SET_LOCATION_DETAIL";
export const SET_USER_LOCATIONS = "SET_USER_LOCATIONS";
